<template>
    <transition name="fade" mode="out-in">
        <router-view></router-view>
    </transition>
</template>

<script>
    export default {
        name: "Main",
        watch:{
            $route (to, from){
                setTimeout(window.jsFrameworkAfterChangeRoute,200);
                setTimeout(window.jsFrameworkAfterChangeRoute,1000);
                setTimeout(window.jsFrameworkAfterChangeRoute,2000);
            }
        }
    }
</script>

<style scoped>
    .fade-enter-active, .fade-leave-active {
        transition: all .5s;
    }

    .fade-enter, .fade-leave-to {
        opacity: 0;
    }
</style>